export class BrowserCleanup {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get browserRuntime() {
        return this.parent;
    }
}
